// Full document loads, so client state bound to the previous identity or
// locale (React Query cache, CASL, session) is dropped. Kept in a module so
// tests can mock it: jsdom does not allow stubbing window.location.
export function assignLocation(path: string) {
  window.location.assign(path);
}

export function reloadLocation() {
  window.location.reload();
}
